/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GlobalClient } from '../../models/global-client';

export interface MonitorGetAllGlobalClientsGet$Params {
}

export function monitorGetAllGlobalClientsGet(http: HttpClient, rootUrl: string, params?: MonitorGetAllGlobalClientsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GlobalClient>>> {
  const rb = new RequestBuilder(rootUrl, monitorGetAllGlobalClientsGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GlobalClient>>;
    })
  );
}

monitorGetAllGlobalClientsGet.PATH = '/Monitor/GetAllGlobalClients';
